/**
 * Value for applicationFeature parameter in button analytics.
 * Usually we send the module name in lower case there, but live studio is an exception (per product).
 * It also matches the relevant page load analytics value.
 */
export const liveStudioApplicationFeature = "Live studio";
